/** @jsx jsx */

import { ReactNode } from 'react';
import { jsx, css } from '@emotion/core';
import { Margin, Text } from '@zapier/design-system';

import SaveButtonGroup from 'app/developer-v3/components/SaveButtonGroup';

import { LayoutStyles } from './constants';

const Styles = {
  layout: css`
    flex: 1 auto;
    height: 100%;
    overflow-y: auto;
    position: relative;
  `,
  editor: css`
    padding: ${LayoutStyles.verticalPadding} ${LayoutStyles.horizontalPadding};
  `,
};

type Props = {
  afterRender?: Node;
  cancelRoute?: string;
  children: ReactNode;
  className: string;
  isDisabled: boolean;
  isSaving: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  saveText?: string;
  title?: string;
};

const defaultProps = {
  className: '',
  isDisabled: true,
  isSaving: false,
};

const EditorBodyLayout = (props: Props) => (
  <main className={props.className} css={Styles.layout}>
    <section css={Styles.editor}>
      {props.title && (
        <Text fontWeight={600} margin="0px 0px 20px" tag="h3" type="Body4">
          {props.title}
        </Text>
      )}
      {props.children}
      {props.onSave && (
        <Margin margin="50px 0px 0px 0px">
          <SaveButtonGroup
            cancelRoute={props.cancelRoute}
            isDisabled={props.isDisabled}
            isSaving={props.isSaving}
            onCancel={props.onCancel}
            onSave={props.onSave}
            saveText={props.saveText}
          />
        </Margin>
      )}
      {props.afterRender}
    </section>
  </main>
);

EditorBodyLayout.defaultProps = defaultProps;

export default EditorBodyLayout;
